export default __webpack_public_path__ + "static/media/logo_painbc.22b0904f.svg";